export const VIDEO_ILLUSTRATION_DISCO_PATH = 'ai-videos-emptystate-disco.mp4';
export const VIDEO_ILLUSTRATION_BASKETBALL_PATH = 'ai-videos-emptystate-basketball.mp4';
export const VIDEO_ILLUSTRATION_PIZZA_PATH = 'ai-videos-emptystate-pizza.mp4';

export const VIDEO_ILLUSTRATION_PLAY_COUNT = 2;
